import memoize from 'lodash/memoize';
import {STATES} from './cardFilter';
import {createSelector} from 'reselect';
import {selectCardById} from 'state/card/cardSelectors';
import {selectDataSourceByCardId} from 'state/dataSource/dataSourceSelectors';
import get from 'lodash/get';

const reselectFiltersByCardId = createSelector(
  (state) => state.cardFilter.filters,
  (state) => state.cardFilter.filtersByCardId,
  (filters, filtersByCardId) =>
    memoize((cardId) =>
      Array.from(filtersByCardId[cardId] || []).map(
        (filterId) => filters[filterId]
      )
    )
);

export const selectFiltersByCardId = (state, cardId) =>
  reselectFiltersByCardId(state)(cardId);

const reselectAppliedFiltersByCardId = createSelector(
  reselectFiltersByCardId,
  (filters) => memoize((cardId) => filters(cardId).filter((f) => f.applied))
);

export const selectAppliedFiltersByCardId = (state, cardId) =>
  reselectAppliedFiltersByCardId(state)(cardId);

const reselectAppliedCombinedFiltersByCardId = createSelector(
  (state, cardId) => reselectAppliedFiltersByCardId(state)(cardId),
  (state, cardId) => selectDataSourceByCardId(state, cardId) || {},
  (filters, dataSource) => {
    return filters.map((filter) => {
      const column =
        dataSource.formulas &&
        dataSource.formulas.find((f) => f.name === filter.column);
      return {
        ...filter,
        column: (column && column.id) || filter.column,
        aggregated:
          (column && (column.isAggregatable === false ? true : undefined)) ||
          filter.aggregated,
      };
    });
  }
);

export const selectAppliedCombinedFiltersByCardId = (state, cardId) =>
  reselectAppliedCombinedFiltersByCardId(state, cardId);

export const selectIsLoadingCardFilters = (state, cardId) =>
  state.cardFilter.stateByCardId[cardId] === STATES.LOADING;

const EMPTY_SEGMENTS = [];
export const selectSegmentsByCardId = (state, cardId) =>
  state.cardFilter.segmentsByCardId[cardId] || EMPTY_SEGMENTS;

const EMPTY_FILTER_GROUPS = [];
export const selectFilterGroupsByCardId = (state, cardId) =>
  state.cardFilter.filterGroupsByCardId[cardId] || EMPTY_FILTER_GROUPS;

export const selectDateRangeByCardId = (state, cardId) =>
  state.cardFilter.dateRangeByCardId[cardId] ||
  get(selectCardById(state, cardId), ['dateInfo', 'dateRange']);

export const selectDateGrainByCardId = (state, cardId) =>
  state.cardFilter.dateGrainByCardId[cardId] ||
  get(selectCardById(state, cardId), [
    'dateInfo',
    'dateGrain',
    'dateTimeElement',
  ]);

export const selectDateRangeFilterByCardId = (state, cardId) => {
  const range = selectDateRangeByCardId(state, cardId);
  return range && range.dateRangeFilter;
};

export const selectOverrideDateRangeByCardId = (state, cardId) => {
  return !!state.cardFilter.overrideDateRangeByCardId[cardId];
};

export const selectFunctionOverridesByCardId = (state, cardId) => {
  return state.cardFilter.functionOverridesByCardId[cardId];
};

export const selectDataControlFiltersByCardId = (state, cardId) => {
  return state.cardFilter.dataControlFiltersByCardId[cardId];
};

export const selectHasQuerystringError = (state, id) =>
  !!state.cardFilter.hasQueryStringErrorById[id];
